export const REMOVE_ZIP_FILE = 'REMOVE_ZIP_FILE';

export const removeZipFile = ({ id, modelType }) => ({
    type: REMOVE_ZIP_FILE,
    payload: {
        id,
        modelType,
    }
});
